import { useEffect } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Information } from "./components/Information/Information";
import { Footer } from "../../../components/Landing/Footer";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useLanding } from "../../../hooks/useLanding";
import { useParams } from "react-router-dom";
import Spinner from "../../../components/Spinner";

export const VerConvocatoriasTwo = () => {
  let { id } = useParams();
  const { convocatoria, getConvocatoriaId } = UseVerConvocatorias();
  const { getConvocatorias, loadingConvocatorias } = useLanding();

  useEffect(() => {
    let mounted = true;
    const numericId = Number(id);
    if (mounted && !isNaN(numericId) && numericId > 0) {
      getConvocatoriaId(numericId);
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, [id]);

  const routes = [
    { icon: <></>, nombre: "Inicio" },
    { icon: <></>, nombre: "Convocatorias" },
    { icon: <></>, nombre: `${convocatoria.nombre_convocatoria || "Detalle de convocatoria"}` },
  ];

  if (loadingConvocatorias) {
    return (
      <Spinner loading={loadingConvocatorias} />
    )
  }

  return (
    <>
      <Header />
      <BreadCrumb routes={routes} />
      <Information convocatorias={convocatoria} />
      <Footer />
    </>
  );
};
